











import { defineComponent, PropType, toRef } from 'vue';
import { useTemplateFilter } from '../../composables/documents/useTemplateFilter';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import AulaMultiselect from '../../../shared/components/select/AulaMultiselect.vue';
import { DocumentTemplateCategoryGroup } from '../../../shared/types';

export default defineComponent({
  name: 'DocumentTemplateFilter',
  components: { AulaMultiselect },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { type: Array as PropType<number[] | string[]>, default: () => [] },
    options: { type: Array as PropType<Array<DocumentTemplateCategoryGroup>>, required: true },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const options = toRef(props, 'options');
    const { multiselectGroups } = useTemplateFilter(options);

    const emitChange = value => {
      emit('change', value);
    };

    return {
      multiselectGroups,
      emitChange,
      iconClassEnum,
    };
  },
});
